import { validateEmail } from 'lib/utils/validateEmail'
import { FC, PropsWithChildren } from 'react'

export type TProps = {
  href?: string | undefined
  target?: string | undefined
} & PropsWithChildren

const Link: FC<TProps> = ({ href, target = '_self', children }) => {
  //@ts-expect-error
  const link: string = href ?? (children ? children[0] : '')

  return (
    <a
      href={`${validateEmail(link) ? 'mailto:' : 'https://'}${link}`}
      rel="noopener noreferrer"
      target={target}
      className="transition-colors"
    >
      {children}
    </a>
  )
}

export { Link }
